import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from 'redux-devtools-extension';
import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
import { createLogger } from "redux-logger";
import createOidcMiddleware from 'redux-oidc';
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import promiseMiddleware from 'redux-promise-middleware';
import createSagaMiddleWare from "redux-saga";
import thunk from 'redux-thunk';
import rootReducer from './redux/reducers';
import { rootSaga } from "./rootSaga";
import userManager from './userManager';

const persistConfig = {
  key: "state",
  storage,
  whitelist: ['ppg', 'application', 'address',
    'personalDetails', 'identityProof', 'intlIdentityProof',
    'history', 'mentalCapacity', 'competitionDetails', 'form', 'applicantDetails', 'facilityDetails', 'individualRoles']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const saga = createSagaMiddleWare();
const middlewares = [thunk, promiseMiddleware, reduxImmutableStateInvariant()];
const oidcMiddleware = createOidcMiddleware(userManager);
if (process.env.NODE_ENV !== "production") {
  middlewares.push(createLogger());
}
middlewares.push(oidcMiddleware);

const configureStore = preloadedState => {
  const store = createStore(
    persistedReducer,
    preloadedState,
    composeWithDevTools(
      applyMiddleware(...middlewares, saga)
    )
  );
  const persistor = persistStore(store);
  saga.run(rootSaga);
  return {store, persistor};
};

export default configureStore;
